import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

const Sidebar = (props) => {
  const [topOffset, setTopOffset] = useState(0);

  useEffect(() => {
    const adjustTopOffset = () => {
      const header = document.querySelector(".nav-header");
      const headerHeight = header ? header.offsetHeight : 0;
      setTopOffset(headerHeight + 77);
    };

    adjustTopOffset();
    window.addEventListener("resize", adjustTopOffset);

    return () => {
      window.removeEventListener("resize", adjustTopOffset);
    };
  }, []);

  return (
    <div
      className="vertical-menu rounded-4 mx-2 overflow-scroll hide-scrollbar"
      style={{
        position: "fixed",
        top: `${topOffset}px`,
        width: "242px",
        height: `calc(100vh - ${topOffset}px)`,
        zIndex: 1000,
        background: "#fff",
      }}
    >
      <SidebarContent />
    </div>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default withRouter(withTranslation()(Sidebar));
